module.exports = __webpack_public_path__ + "img/苏州恩加壹汽车服务有限公司.a623c282.jpg";